import React from 'react'
import { connect } from 'react-redux'
import { uiButtonPressed, setPopupScreen, setAutoPlayReStart } from '../../../redux/actions'
import { openSettingsScreen } from 'macguffin/redux/actions'
import { setSpins } from 'macguffin/components/autoplay/actions'
import { BUTTON_CLOSE, POPUP_SCREENS } from '../../../redux/constants'
import SvgIcon from '../../svg/SvgIcon'
import { stopPropagation } from '../../../utils'

/**
 * This is the Main UI component of Autoplay.
 */
@connect(state => ({
  autoPlay: state.autoPlay,
  popupScreen: state.UI.popupScreen,
}), { setSpins, uiButtonPressed, setPopupScreen, openSettingsScreen, setAutoPlayReStart })
export default class Autoplay extends React.Component {
  /**
   * Stop current autoplay if it's active, or open the autoplay settings.
   */
  toggleAutoPlay = () => {
    const {
      autoPlay: { spinsLeft },
      uiButtonPressed,
      popupScreen,
      setSpins,
      setPopupScreen,
      setAutoPlayReStart,
    } = this.props
    if (spinsLeft) {
      setSpins(0)
      setPopupScreen(null)
      setAutoPlayReStart(false)
      uiButtonPressed(BUTTON_CLOSE)
    } else {
      setPopupScreen(popupScreen === POPUP_SCREENS.AUTOPLAY ? null : POPUP_SCREENS.AUTOPLAY)
      uiButtonPressed(popupScreen === POPUP_SCREENS.AUTOPLAY ? BUTTON_CLOSE : POPUP_SCREENS.AUTOPLAY)
    }
  }

  /**
   * Renders the DOM element of the autoplay feature.
   */
  render() {
    const { autoPlay, scale = 1, popupScreen, svgIcons } = this.props

    const autoplayPopupVisible = popupScreen === POPUP_SCREENS.AUTOPLAY

    let style = {}
    if (window.innerWidth < 900 && window.innerWidth > window.innerHeight) {
      style = scale < 1 ? { transform: `scale(${scale})` } : ''
    }

    let iconNameSufix
    if (autoPlay.spinsLeft) {
      iconNameSufix = '-active'
    } else if (autoplayPopupVisible) {
      iconNameSufix = '-selected'
    } else if (autoPlay.disabled) {
      iconNameSufix = '-disabled'
    } else {
      iconNameSufix = ''
    }

    const injectedElement = (
      <text
        className={`text ${autoPlay.spinsLeft === Infinity ? 'infinity' : ''}`}
        x="50%"
        y={autoPlay.spinsLeft === Infinity ? '44%' : '50%'}
        textAnchor="middle"
        alignmentBaseline="central"
        dominantBaseline="central"
      >
        {(autoPlay.spinsLeft === Infinity ? '\u221E' : autoPlay.spinsLeft) || null}
      </text>
    )

    return (
      <div className={`auto-play ${autoPlay.disabled ? 'disabled' : ''}`} onTouchMoveCapture={stopPropagation} style={{ ...style }}>
        < SvgIcon
          svgIcons={svgIcons}
          iconName={`autoplay${iconNameSufix}`}
          hasClickIcon={true}
          onClick={this.toggleAutoPlay}
          disabled={autoPlay.disabled}
          injectedElement={injectedElement}
        />
      </div>
    )
  }
}
